import React from 'react';

import Container from 'layouts/container/Container';
import style from "./TestLottieAnimation.module.css";


const LottieAnimation = () => {
    return (
        <Container>
            <Container maxWidth={1200} backgroundColor={"black"}>
                
            </Container>
        </Container>

    );
};

export default LottieAnimation;
